<template>
  <div>
    <tk-flex middle>
      <h1 class="section-header fill">更新记录</h1>
      <v-btn icon @click="add" v-if="isAdmin"><v-icon>add</v-icon></v-btn>
    </tk-flex>
    <v-card v-if="total === 0" class="empty-message">
      还没有发布任何软件版本
    </v-card>
    <template v-if="releases">
      <v-card v-for="release in releases" :key="release.id" class="m-b-20">
        <v-card-title>
          <div>
            <div class="headline">v{{release.version}}
              <span v-if="release.tags && release.tags.length">
                <v-chip v-for="tag in release.tags" :key="tag" small>{{tag}}</v-chip>
              </span>
            </div>
            <span class="grey--text">{{release.created_at | date}}</span>
          </div>
        </v-card-title>
        <v-card-text>
          <pre>{{release.release_note}}</pre>
        </v-card-text>
        <v-card-actions>
          <v-btn flat @click="openAppStore" :disabled="!release.ios_available">苹果应用商店</v-btn>
          <v-btn flat @click="downloadApk(release)" :disabled="!release.android_available">下载安卓安装包</v-btn>
          <v-btn  v-if="isAdmin" flat color="primary" @click="edit(release)">编辑</v-btn>
          <v-btn  v-if="isAdmin" flat color="error" @click="del(release)">删除</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </div>
</template>

<script>
import gql from 'graphql-tag'
export default {
  name: 'appReleases',
  data: function () {
    return {
      passwordDialog: false,
      form: [{
        name: 'version',
        type: 'String',
        label: '版本号',
        placeholder: '如：1.0.2'
      }, {
        name: 'release_note',
        type: 'textarea',
        label: '更新说明'
      }, {
        name: 'tags',
        type: 'combobox',
        label: '标签'
      }, {
        name: 'apk_url',
        label: '安卓安装包'
      }, {
        name: 'ios_available',
        type: 'Boolean',
        label: 'ios已发布'
      }],
      validator: (data) => {
        if (!data.version || !data.release_note) {
          this.$tkGlobal.alert.show('缺少必填项')
          return []
        }
      },
      total: 0,
      page: 1
    }
  },
  apollo: {
    total: {
      query: gql`subscription($projectId: Int!) {
        app_releases_aggregate(where: {project_id: {_eq: $projectId}}) {
          aggregate {
            count
          }
        }
      }`,
      variables () {
        return {
          projectId: this.project.id
        }
      },
      update: data => data.app_releases_aggregate.aggregate.count
    },
    releases: {
      query: gql`subscription ($offset: Int,$projectId: Int!) {
        app_releases (where: {project_id: {_eq: $projectId}}, offset: $offset, order_by: {created_at: desc}) {
          id
          apk_url
          version
          release_note
          tags
          ios_available
          android_available
          created_at
          updated_at
        }
      }`,
      variables () {
        return {
          offset: (this.page - 1) * 12,
          projectId: this.project.id
        }
      },
      update: data => data.app_releases
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    project () {
      return this.$store.state.project
    },
  },
  methods: {
    openAppStore () {
      this.$tkGlobal.alert.show('待完成')
    },
    downloadApk (release) {
      window.open(release.apk_url)
    },
    async add () {
      let data = await this.$tkGlobal.dialogForm.show('创建新版本', this.form, null, this.validator)
      await this.$apollo.mutate({
        mutation: gql`mutation MyMutation($object: app_releases_insert_input!) {
          insert_app_releases_one(object: $object) {
            id
          }
        }`,
        variables: {
          object: {
            ...data,
            project_id: this.project.id,
            created_by: this.user.id
          }
        } })
    },
    async edit (item) {
      if (typeof item.attachment === 'string') item.attachment = JSON.parse(item.attachment)
      let data = await this.$tkGlobal.dialogForm.show('编辑版本信息', this.form, item, this.validator)
      await this.$apollo.mutate({
        mutation: gql`mutation MyMutation($id: uuid = "", $set: app_releases_set_input!) {
          update_app_releases_by_pk(pk_columns: {id: $id}, _set: $set) {
            id
          }
        }`,
        variables: {
          id: item.id,
          set: data
        } })
    },
    async del (item) {
      await this.$tkGlobal.confirm.show('确定要删除这条记录吗？')
      this.$apollo.mutate({
        mutation: gql`mutation MyMutation($id: uuid!) {
          delete_app_releases_by_pk(id: $id) {
            id
          }
        }`,
        variables: { id: item.id } })
    },
    onPagination (page) {
      this.page = page
    }
  }
}
</script>

<style scoped>
</style>
